import { useSyncExternalStore } from "react";

const subscribe = (callback: () => void) => {
  window.visualViewport?.addEventListener("resize", callback);
  window.visualViewport?.addEventListener("scroll", callback);
  window.addEventListener("resize", callback);
  return () => {
    window.visualViewport?.removeEventListener("resize", callback);
    window.visualViewport?.removeEventListener("scroll", callback);
    window.removeEventListener("resize", callback);
  };
};
const height = () => window.visualViewport?.height ?? window.innerHeight;
const top = () => Math.max(0, window.visualViewport?.offsetTop ?? 0);
const inset = () =>
  Math.max(
    0,
    window.innerHeight -
      (window.visualViewport?.height ?? window.innerHeight) -
      (window.visualViewport?.offsetTop ?? 0),
  );

/** Keep the floating panel above phone keyboards without scrolling its host page.
 * iOS pans the visual viewport down by `top` instead of shrinking the layout
 * viewport, so a full-screen panel must start there, not at the layout top. */
export function useVisualViewport() {
  return {
    height: useSyncExternalStore(subscribe, height),
    top: useSyncExternalStore(subscribe, top),
    bottom: useSyncExternalStore(subscribe, inset),
  };
}
